<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    min-height="min-h-[200px]"
    @close="$emit('close')"
  >
    <div class="relative -mt-4 rounded bg-white px-2 md:mt-0">
      <h3 class="text-left text-xl text-dark-gray">Remove Capacity</h3>

      <div class="my-4 text-left">
        <p class="text-sm text-steel-800">
          Are you sure you want to remove truck:
          <span class="font-semibold"> {{ capacity.carrier_vehicle_id }} </span
          >?
        </p>
      </div>

      <section class="mt-6 flex justify-end gap-3">
        <ButtonComponent @click="emit('close')"> Not Now </ButtonComponent>
        <ButtonComponent
          variant="primary"
          class="flex min-w-[130px] justify-center"
          @click="handleRemove"
        >
          <svg
            v-if="isCreateTruckPostingLoading"
            class="loading relative h-5 w-full"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
              stroke="currentColor"
              stroke-width="3"
            />
            <path
              d="M16 1V7L20 4L16 1Z"
              fill="currentColor"
            />
            <path
              d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
              stroke="currentColor"
              stroke-width="3"
            />
          </svg>
          <p v-else>Yes, Remove</p>
        </ButtonComponent>
      </section>
    </div>
  </bottom-sheet>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { BottomSheet, ButtonComponent } from '@/components';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  capacity: {
    type: Object,
  },
});

const store = useStore();
const toast = useToast();

const emit = defineEmits(['close']);

const isCreateTruckPostingLoading = computed(
  () => store.state.loads.is_create_truck_posting_loading
);

const handleRemove = async () => {
  console.log('Remove truck:', props.capacity?.id);

  const res = await store.dispatch('loads/updateTruckPosting', {
    id: props.capacity?.id,
    is_active: false,
  });

  if ([200, 201, 204].includes(res?.status) && res.data) {
    toast.open({
      message: 'Capacity successfully removed.',
      position: 'top-right',
      duration: 5000,
    });
    emit('close');
  } else {
    toast.open({
      message: 'There was an error, please try again.',
      type: 'error',
      position: 'top-right',
      duration: 5000,
    });
    emit('close');
  }
};
</script>

<style scoped>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
